<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main
    fxFlex
    class="subnav__exists"
    style="position: relative"
    [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="nomargin">Invoices</h2>
      </sbnb-page-header>
    </app-feature-flag-tabs>
    <div class="invoices__header" fxLayout>
      <app-feature-flag-tabs fxLayout>
        <h2 class="nomargin" fxFlex>Invoices</h2>
      </app-feature-flag-tabs>

      <div *ngIf="legacyInvoices" fxLayoutAlign="start center" fxLayoutGap="12px">
        <button class="button__small button__secondary" mat-flat-button>
          <a [href]="legacyInvoices.url" target="_blank">Show older invoices</a>
        </button>
        <button class="button__small" mat-flat-button (click)="reportProblem()">Report a problem</button>
      </div>
    </div>

    <sbnb-invoices-table [loading]="loading" [invoices]="invoices"></sbnb-invoices-table>

    <div class="w-full flex align-center justify-center">
      <sbnb-button
        *ngIf="!loading && hasMoreEntries"
        [disabled]="loadingMore"
        size="mini"
        type="text"
        (click)="loadInvoices()">
        <span class="flex gap-2 items-center">
          <sbnb-loading-spinner [size]="16" *ngIf="loadingMore"></sbnb-loading-spinner>
          <span>Load more...</span>
        </span>
      </sbnb-button>
    </div>

    <div
      *ngIf="!loading && invoices && invoices.length > 0"
      fxHide.lt-md
      class="invoices__thank-you"
      fxLayout
      fxLayoutAlign="center center"
      fxLayoutGap="8px">
      <span>Thank you for supporting us</span>
      <span>❤️</span>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
